import { styled, keyframes } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export function generateFadeOutKeyframes(
    displayDuration: number,
    transitionDuration: number,
    reduceMotion?: boolean
): ReturnType<typeof keyframes> {
    const totalTime = displayDuration + transitionDuration * 2;
    let inPercent = (transitionDuration / totalTime) * 100;
    let movePercent = 5;

    //if user prefers reduced motion, don't move the image and fade in/out twice as fast
    if (reduceMotion) {
        inPercent = inPercent / 2;
        movePercent = 0;
    }

    return keyframes`
        0% {
            opacity: 0;
            transform: translateX(${movePercent}%);
        }
        ${inPercent.toFixed(6)}% {
            opacity: 1;
            transform: translateX(0);
        }
        ${(100 - inPercent).toFixed(6)}% {
            opacity: 1;
            transform: translateX(0);
        }
        100% {
            opacity: 0;
            transform: translateX(-${movePercent}%);
        }
    `;
}

export const Container = styled.div`
    ${redundantCssFromKebab("display", "grid")}
    ${redundantCssFromKebab("grid-template-columns", "100%")}
`;

export type RotatingItemProps = {
    readonly hasAnimation: boolean;
    readonly displayDuration: number;
    readonly transistionDuration: number;
};

export const RotatingItem = styled.div<RotatingItemProps>`
    animation-duration: ${({
        hasAnimation,
        displayDuration,
        transistionDuration
    }) =>
        hasAnimation ? `${displayDuration + transistionDuration}ms` : "0ms"};
    animation-name: ${({
        hasAnimation,
        displayDuration,
        transistionDuration
    }) =>
        hasAnimation
            ? generateFadeOutKeyframes(displayDuration, transistionDuration)
            : "none"};
    animation-timing-function: ease-out;
    display: flex;
    grid-column: 1;
    grid-row: 1;
    height: 100%;
    opacity: 0;
    position: relative;

    @media (prefers-reduced-motion: reduce) {
        animation-name: ${({
            hasAnimation,
            displayDuration,
            transistionDuration
        }) =>
            hasAnimation
                ? generateFadeOutKeyframes(
                      displayDuration,
                      transistionDuration,
                      true
                  )
                : "none"};
    }
`;
